// Import required dependencies
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Ensure carousel styles are imported
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { COUNTRY_CODE } from '@src/config/constant';

const isCountryId = COUNTRY_CODE ==='id' ? true : false;

interface ReactSliderProps {
  screenType: string;
}

// Shared styles for the carousel content

  

// Component for slide content with text
const SlideWithText = ({
  title,
  highlight,
  highlightwhite,
  description,
  image,
}: {
  title: string;
  highlight: string;
  highlightwhite:string;
  description: string;
  image: string;
}) => (
  <div className="registered-slider-outer">
    <div className="slider-txt-outer">
      <span className="slider-title">{title}</span>
      <div className="hightlight-txt">
        <span className="hightlight-main">{highlight}</span>
        <span>{highlightwhite}</span>
      </div>
      <span className="discreption-txt">{description}</span>
    </div>
    <div className="slider-img-outer">
    <img src={image} alt="slide"/>
    </div>
  </div>
);

// Component for slide content with only an image
const SlideWithImage = ({ image }: { image: string }) => (
  <div>
    <img src={image} alt="slide"/>
  </div>
);

// Functional Component for the React Slider
const ReactSlider = ({ screenType }: ReactSliderProps) => {
  const registerSlides = [
    {
      title: "100% Timely",
      highlight: "Referral ",
      highlightwhite: "Fee Payout",
      description: "Receive payments on time without any delays",
      image: `/images/Layer_1${isMobile ? "_mobile" : ""}.png`,
    },
    {
      title: "No Paperwork",
      highlight: "100% ",
      highlightwhite: "Digital Process",
      description: "Receive payments on time without any delays",
      image: `/images/Asset_1${isMobile ? "_mobile" : ""}.png`,
    },
    {
      title: "No Paperwork",
      highlight: "100% ",
      highlightwhite: "Digital Process",
      description: "Receive payments on time without any delays",
      image: `/images/F_Layer_1${isMobile ? "_mobile" : ""}.png`,
    },
  ];

  const loginSlides = isCountryId
    ? [
        { image: "/images/image138.png" },
        { image: "/images/ClaimInsurance1.png" },
        { image: "/images/AddUser201.png" },
        { image: "/images/Group1000006483.png" },
      ]
    : [
        { image: "/images/Group_1000006483.png" },
        { image: "/images/Group2_1000006483.png" },
        { image: "/images/Group3_1000006483.png" },
      ];

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <div className="demo-carousel">
      <Carousel
        showArrows={false}
        autoPlay
        interval={3000}
        showThumbs={false}
        infiniteLoop
        showStatus={false}
      >
        {screenType === "Register"
          ? registerSlides.map((slide, index) => (
              <SlideWithText
                key={index}
                title={slide.title}
                highlight={slide.highlight}
                highlightwhite={slide.highlightwhite}
                description={slide.description}
                image={slide.image}
              />
            ))
          : loginSlides.map((slide, index) => (
              <SlideWithImage key={index} image={slide.image} />
            ))}
      </Carousel>
    </div>
  );
};

export default ReactSlider;
